export default __webpack_public_path__ + "static/media/784.b361af49.png";